import React from "react";


const Options = ({ options, disabled, multi, chosenOption, setChosenOption, error, toggle }) => {

    const toggleChosenOption = (option) => {
        if (chosenOption.includes(option)) {
            setChosenOption(chosenOption.filter(r => r !== option))
        } else {
            setChosenOption([...chosenOption, option])
        }
    }

    return <> <div className="row" style={error ? { justifyContent: 'flex-start', gap: '20px', border: '1px solid red', borderRadius: '4px', padding: '5px 2px' } : { justifyContent: 'flex-start', gap: '20px' }}>
        {options.map(option => <button key={option} disabled={disabled} className="option-block" style={(multi ? chosenOption.includes(option) : chosenOption === option) ? { backgroundColor: '#F89456', color: 'white', borderColor: '#E6722A' } : {}} onClick={() => { multi ? toggleChosenOption(option) : (toggle && chosenOption === option) ? setChosenOption('') : setChosenOption(option) }}>{option}</button>)}
    </div>
        {error && <p style={{ margin: 0, fontWeight: '500', fontSize: '15px', color: '#D90000' }}>{multi ? 'Please choose one or more options.' : 'Please pick an option.'}</p>}
    </>
}

export default Options